import {
  ChimneySensorFieldsDto,
  Flue,
  FlueBurnMetricAggregateValuesDto,
  FlueDto,
  Sweeping,
  SweepingDto,
  SweepingImpl,
} from "firefly-shared-ts-domain";
import { merge } from "lodash";
import { TFunction } from "i18next";
import { DateTime } from "luxon";

export interface FlueStatusDto extends FlueDto {
  sensorFields?: ChimneySensorFieldsDto;
  metricValuesSinceSweep?: FlueBurnMetricAggregateValuesDto;
  metricValuesAtLastSweep?: FlueBurnMetricAggregateValuesDto;
  lastSweeping?: SweepingDto;
}

export class FlueStatus extends Flue {
  readonly sensorFields?: ChimneySensorFieldsDto;
  readonly metricValuesSinceSweep?: FlueBurnMetricAggregateValuesDto;
  readonly metricValuesAtLastSweep?: FlueBurnMetricAggregateValuesDto;
  readonly lastSweeping?: Sweeping;
  private _cachedAttentions: Array<string> | undefined = undefined;
  constructor(args: FlueStatusDto) {
    super(args);
    this.sensorFields = args.sensorFields;
    this.metricValuesSinceSweep = args.metricValuesSinceSweep;
    this.metricValuesAtLastSweep = args.metricValuesAtLastSweep;
    this.lastSweeping =
      args.lastSweeping != null
        ? new SweepingImpl(args.lastSweeping)
        : undefined;
  }

  getAttentions(t: TFunction<"firefly-shared-ts-domain">): Array<string> {
    if (this._cachedAttentions != null) {
      return this._cachedAttentions;
    }

    const attentions = [...super.getAttentions(t)];
    if (!this.flue.sweepedDuringSensorInstallation) {
      if (this.lastSweeping == null) {
        attentions.push(
          t("The flue needs a sweeping registration, since ...", {
            date:
              this.sensorOperationalAt?.toLocaleString(DateTime.DATE_SHORT) ??
              "?",
          })
        );
      }
    }
    this._cachedAttentions = attentions;
    return attentions;
  }

  toDto(): FlueStatusDto {
    return {
      ...super.toDto(),
      sensorFields: this.sensorFields,
      metricValuesSinceSweep: this.metricValuesSinceSweep,
      metricValuesAtLastSweep: this.metricValuesAtLastSweep,
      lastSweeping: this.lastSweeping?.toDto(),
    };
  }

  update(updatedFlue: FlueDto): FlueStatus {
    const thisDto = merge(this.toDto(), updatedFlue) as FlueStatusDto;
    return new FlueStatus(thisDto);
  }
}
